// extracted by mini-css-extract-plugin
module.exports = {"container":"Caption_container__2HeOX"};